import type { GetLinkedResourcesOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export interface GetLinkedResourcesQueryParams extends GetLinkedResourcesOpenAPIQueryParams {}

export function querySerializer(queryParams: GetLinkedResourcesQueryParams) {
  const searchParams = new URLSearchParams();

  if ((queryParams.limit ?? 0) > 0) {
    searchParams.set('limit', String(queryParams.limit));
  }

  if ((queryParams.offset ?? 0) > 0) {
    searchParams.set('offset', String(queryParams.offset));
  }

  if (queryParams.sort) {
    searchParams.set('sort', queryParams.sort);
  }

  if (queryParams.expand) {
    searchParams.set('expand', queryParams.expand.join(','));
  }

  if (queryParams.filter) {
    searchParams.set('filter', queryParams.filter);
  }

  if (queryParams.query) {
    searchParams.set('query', queryParams.query);
  }

  return searchParams.toString();
}
